import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import config from "config";
import React from "react";
import ReactToPrint from "react-to-print";
import ReactHtmlParser from "react-html-parser";
import "./viewpo.css";
import vendorApiCall from "vendorApiCall";
import { toWords } from 'number-to-words';

let apiPath = "/vendor/api/vendor.php";

class ViewPO extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      purchaseOrder: this.props.purchaseOrder,
      receiptDesign: this.props.currentDesign,
      isPOFetching: this.props.isPOFetching,
      receiptDataHTML: "",
      orderTotal : 0,
    };
  }

  async componentDidMount() {
    await this.fetchTemplate(); // Wait for fetchTemplate to complete
    this.setDesignParameters(this.props.purchaseOrder); // Now set design parameters
  }

  // METHOD TO CLOSE VIEW PO MODAL
  closeViewPOModal = () => {
    this.props.closePOModal();
  };

  fetchTemplate = async () => {
    const requestData = {
      institute_id: this.props.purchaseOrder.iid,
    };
    let jsonResponse = await vendorApiCall.makeApiCall(
      "accounting_getPOTemplate",
      requestData,
      apiPath
    );
    if (jsonResponse.success) {
      const apiResult = jsonResponse.APIResult;
      if (apiResult.success === "true") {
        const templateConfig = Object.values(apiResult?.data)[0]
          ?.templateConfiguration;
        if (templateConfig) {
          this.setState({ receiptDesign: templateConfig });
        }
      }
    }
  };

  formatDate = (dateString) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const date = new Date(dateString);

    if (isNaN(date)) {
      return "Invalid Date";
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  setDesignParameters = (purchaseOrder) => {
    let parametersArray = [];
    let receiptDesign = this.state.receiptDesign;

    // debugger;
    // let vendorFullAddress = purchaseOrder.prDetails?.VendorAddress?.Address.address + ',' + purchaseOrder.prDetails?.VendorAddress?.Address.city + ',' + purchaseOrder.prDetails?.VendorAddress?.Address.country + ',' + purchaseOrder.prDetails?.VendorAddress?.Address.state + '-' + purchaseOrder.prDetails?.VendorAddress?.Address.zipcode;
    // let ContactPersonName = purchaseOrder.prDetails?.VendorContactPerson[0]?.firstName + " " + purchaseOrder.prDetails?.VendorContactPerson[0]?.lastName;
    // let ContactPersonMobile = purchaseOrder.prDetails?.VendorContactPerson[0]?.mobileNumber;
    let vendorAddress = purchaseOrder.prDetails?.VendorAddress?.Address;
    let vendorFullAddress =
      vendorAddress == undefined
        ? ""
        : `${vendorAddress?.address || ""}, ${vendorAddress?.city || ""}, ${
            vendorAddress?.country || ""
          }, ${vendorAddress?.state || ""} - ${vendorAddress?.zipcode || ""}`;
    let vendorContactPerson = purchaseOrder.prDetails?.VendorContactPerson?.[0];
    let ContactPersonName =
      vendorContactPerson == undefined
        ? ""
        : `${vendorContactPerson?.firstName || ""} ${
            vendorContactPerson?.lastName || ""
          }`;
    let ContactPersonMobile = vendorContactPerson?.mobileNumber || "";

    let parameters = {
      Organisation_name: "",
      Organisation_logo: "",
      Vendor_name: purchaseOrder.prDetails?.VendorName,
      Vendor_address: vendorFullAddress.length > 0 ? vendorFullAddress : "",
      Contact_person_name: ContactPersonName,
      Contact_person_mobile: ContactPersonMobile,
      PO_date: this.formatDate(purchaseOrder.requestedOn),
      PO_number: purchaseOrder.poNumber,
      PR_number: purchaseOrder.prNumber,
      PO_status: purchaseOrder.poStatus,
      PO_table: "",
      PO_table_sr_no: "",
      PO_table_item_name: "",
      PO_table_item_quantity: "",
      PO_table_rate: "",
      PO_table_amount: "",
      PO_amount: purchaseOrder.prDetails?.poAmount,
    };

    parametersArray.push(parameters);

    let receiptHTML = this.state.receiptDesign;

    parametersArray.forEach((parameters, index) => {
      for (let fieldName in parameters) {
        if (receiptHTML.includes("{" + fieldName + "}")) {
          if (
            fieldName === "Organisation_logo" &&
            parameters[fieldName] != undefined
          ) {
            // Replace the placeholder with its value
            var find = "{" + fieldName + "}";
            var regularExpression = new RegExp(find, "g");
            receiptHTML = receiptHTML.replace(
              regularExpression,
              ' <img  src="' +
                parameters[fieldName] +
                '" width="70px" height="70px">'
            );
          } else if (
            fieldName == "PO_table_sr_no" ||
            fieldName == "PO_table_item_name" ||
            fieldName == "PO_table_item_quantity" ||
            fieldName == "PO_table_rate" ||
            fieldName == "PO_table_amount"
          ) {
            receiptHTML = this.modifyAndReturnUpdatedHTML(
              receiptHTML,
              purchaseOrder
            );
          } else {
            // Replace the placeholder with its value
            var find = "{" + fieldName + "}";
            var regularExpression = new RegExp(find, "g");
            receiptHTML = receiptHTML.replace(
              regularExpression,
              parameters[fieldName]
            );
          }
        }
      }
    });

    this.setState({
      receiptDataHTML: receiptHTML,
      receiptDesign,
    });
  };

  modifyAndReturnUpdatedHTML = (htmlString, purchaseOrder) => {
    // Create a new DOMParser instance
    const parser = new DOMParser();
    // debugger;

    // Parse the HTML string into a DOM Document
    const doc = parser.parseFromString(htmlString, "text/html");

    // Find the table with the class 'PO_table'
    const poTable = doc.querySelector("table.PO_table");

    // Check if the table exists
    if (!poTable) {
      return htmlString; // If no table is found, return the original HTML
    }

    var originalTableHTML = poTable.outerHTML;

    // Get the tbody element inside the table (assuming rows are in tbody)
    const tbody = poTable.querySelector("tbody");

    // Get the first row as a template (to duplicate for multiple assets)
    const templateRow = tbody.querySelector("tr");

    // Remove all existing rows from the tbody (to replace with dynamic rows)
    while (tbody.firstChild) {
      tbody.removeChild(tbody.firstChild);
    }
      var poTableTotalPOAmount = 0;
      var taxPoAmount = 0;
      var discountTotal = 0;

    // Loop through asset details and add a new row for each asset
    Object.values(purchaseOrder.prDetails?.assetDetails).forEach(
      (asset, index) => {
        // Clone the template row for each asset
        const newRow = templateRow.cloneNode(true);

        // Find the cells (td elements) in the new row
        const cells = Array.from(newRow.querySelectorAll("td"));

        // Get asset details to populate in the new row
         const poTableSrNo = index + 1;
            const poTableItemName = asset.assetName;
            const poTableQuantity = purchaseOrder.prDetails?.ApprovedQuantity[asset.assetId];
            const poTableRatePerUnit = purchaseOrder.prDetails?.vendorPrice[asset.assetId] ? purchaseOrder.prDetails?.vendorPrice[asset.assetId].pricePerUnit : 0;
            const poTableTotalAmount = (poTableQuantity * poTableRatePerUnit * 100) / 100;
            poTableTotalPOAmount = poTableTotalPOAmount +  poTableTotalAmount;
            const discountAmount = purchaseOrder.prDetails?.vendorPrice[asset.assetId] ? purchaseOrder.prDetails?.vendorPrice[asset.assetId].discountAmount : 0;
            const taxTableAmount = purchaseOrder.prDetails?.vendorPrice[asset.assetId] ? purchaseOrder.prDetails?.vendorPrice[asset.assetId].taxAmount : 0;
            taxPoAmount = taxPoAmount + taxTableAmount;
            discountTotal = discountTotal + discountAmount;
            const uom = purchaseOrder.prDetails?.assetDetails[asset.assetId] ? purchaseOrder.prDetails?.assetDetails[asset.assetId].assetUOM : 0;
            const discountPercentage = purchaseOrder.prDetails?.vendorPrice[asset.assetId] ? purchaseOrder.prDetails?.vendorPrice[asset.assetId].discountPercentage : 0;
            const actualAmount = purchaseOrder.prDetails?.vendorPrice[asset.assetId] ? purchaseOrder.prDetails?.vendorPrice[asset.assetId].actualAmount : 0;
            const actualPricePerUnit = purchaseOrder.prDetails?.vendorPrice[asset.assetId] ? purchaseOrder.prDetails?.vendorPrice[asset.assetId].actualPricePerUnit : 0;
            const taxPercentage = purchaseOrder.prDetails?.vendorPrice[asset.assetId] ? purchaseOrder.prDetails?.vendorPrice[asset.assetId].taxPercentage : 0;
            // Replace placeholders in the cells
            cells.forEach((cell) => {
                if (cell.textContent.trim() === "{PO_table_sr_no}") {
                    cell.textContent = poTableSrNo;
                }
                if (cell.textContent.trim() === "{PO_table_item_name}") {
                    cell.textContent = poTableItemName;
                }
                if (cell.textContent.trim() === "{PO_table_item_quantity}") {
                    cell.textContent = poTableQuantity;
                }
                 if (cell.textContent.trim() === "{po_table_item_uom}") {
                    cell.textContent = uom;
                }
                if (cell.textContent.trim() === "{PO_table_rate}") {
                    cell.textContent = parseFloat(poTableRatePerUnit.toFixed(4));
                }
                if (cell.textContent.trim() === "{PO_table_amount}") {
                    cell.textContent = parseFloat(poTableTotalAmount.toFixed(4));
                }
                if (cell.textContent.trim() === "{po_table_item_discount}") {
                    cell.textContent = discountAmount;
                }
                if (cell.textContent.trim() === "{po_table_item_discount_percentage}") {
                    cell.textContent = discountPercentage;
                }
                 if (cell.textContent.trim() === "{po_table_item_actual_amount}") {
                    cell.textContent = actualAmount;
                }
                 if (cell.textContent.trim() === "{po_table_item_actual_unit_per_price}") {
                    cell.textContent = actualPricePerUnit;
                }
                if (cell.textContent.trim() === "{po_table_item_actual_tax_percentage}") {
                    cell.textContent = taxPercentage;
                }

                if (cell.textContent.trim() === "{PO_table_tax_type}") {
                    cell.textContent = taxPercentage;
                }

                 if (cell.textContent.trim() === "{po_table_item_tax}") {
                    cell.textContent = Number(taxTableAmount?.toFixed(4));
                }

                // if (cell.textContent.trim() === "{PO_amount}") {
                //     cell.textContent = poTableTotalPOAmount;
                // }
            });
        // Append the new row to the tbody
        tbody.appendChild(newRow);
      }
    );

        // Replace the placeholder for the total PO amount anywhere in the table
        poTable.innerHTML = poTable.innerHTML.replace(/{PO_amount}/g, poTableTotalPOAmount);

        // Get the updated table's outerHTML
        const updatedTableHTML = poTable.outerHTML;

        // Replace the original table in the htmlString with the updated table
        let updatedHTMLString = htmlString.replace(originalTableHTML, updatedTableHTML);

        // Now replace {PO_amount_words} in the entire updated HTML string
        updatedHTMLString = updatedHTMLString.replace(/{PO_net_payable_amount_words}/g, toWords(parseFloat(poTableTotalPOAmount)));
        updatedHTMLString = updatedHTMLString.replace(/{PO_tax_amount}/g,Number(taxPoAmount.toFixed(4)));
        updatedHTMLString = updatedHTMLString.replace(/{PO_discount_total_amount}/g,Number(discountTotal.toFixed(4)));

        // Return the updated HTML string
        return updatedHTMLString;
  };

  render() {
    return (
      <div className="quotation-modal">
        <div className="quotation-modal-content">
          <div
            className="modal-header"
            style={{
              color: "#202020",
              background: "white",
              border: "none",
              cursor: "pointer",
            }}
          >
            <h3>Purchase Order View</h3>
            <div>
              {/* <h3>{ config.instructorInfo.InstituteShortName.length > 0 ? config.instructorInfo.InstituteShortName : 'Vmedulife' }</h3> */}

              {this.state.receiptDataHTML.length > 0 && (
                <ReactToPrint
                  trigger={() => {
                    return (
                      <FontAwesomeIcon
                        icon={["fas", "print"]}
                        style={{ fontSize: "16px", marginRight: "20px" }}
                      />
                    );
                  }}
                  content={() => this.printReceipt}
                />
              )}
              <FontAwesomeIcon
                icon={["fas", "times"]}
                size="lg"
                color="#000"
                onClick={() => this.closeViewPOModal()}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
          <div className="modal-body">

          {this.state.receiptDataHTML.length > 0 ? (
            <div
              className="p-4"
              style={{ marginTop: "5%" }}
              ref={(el) => (this.printReceipt = el)}
            >
              {this.state.isPOFetching ? (
                <div className="w-100 h-100 align-center bold text-black-50">
                  Loading Design . . .&nbsp;
                  <FontAwesomeIcon
                    icon={["fas", "circle-notch"]}
                    size="lg"
                    className="rotate"
                  />
                </div>
              ) : (
                ReactHtmlParser(this.state.receiptDataHTML)
              )}
            </div>
          ) : (
            <p className="p-4">PO template is not design you can not download the PO.</p>
          )}
        </div>
        </div>
      </div>
    );
  }
}

export default ViewPO;
